<div class="menu-option-content-container">
<app-menu-options [nextPossibleSteps]="nextPossibleSteps" (onActionSelected)="onAction($event)"></app-menu-options>
</div>
